<script setup lang="ts">
  import { computed } from 'vue';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import LabSection from './LabSection.vue';

  const lab = useMatrixFillLabContext();

  const rows = computed(() => lab.elementContract.value);
  const covered = computed(() => rows.value.filter((row) => row.hasEngine).length);
  const unsupportedInMatrix = computed(() => rows.value.filter((row) => !row.hasEngine && row.count > 0));
</script>

<template>
  <LabSection
    title="Contrato de elementos"
    :badge="`${covered} de ${rows.length} tipos com motor`"
    hint="Cada tipo do construtor precisa de uma definição no motor (controle, validação, colunas do Excel). Sem definição, o tipo é renderizado como não suportado e não entra no relatório."
    data-testid="lab-contract"
  >
    <div class="overflow-x-auto">
      <table class="w-full border-collapse text-[11px]">
        <thead>
          <tr class="text-left text-[10px] uppercase text-[var(--color-gray-05)]">
            <th class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              Tipo
            </th>
            <th class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              Rótulo no construtor
            </th>
            <th class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              Motor
            </th>
            <th class="border-b border-[var(--color-gray-02)] py-1 text-right">
              Nesta matriz
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="row.type"
            :class="{ 'bg-red-50': !row.hasEngine && row.count > 0 }"
          >
            <td class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              <code class="text-[10px]">{{ row.type }}</code>
            </td>
            <td class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              {{ row.label }}
            </td>
            <td class="border-b border-[var(--color-gray-02)] py-1 pr-2">
              <span
                class="rounded-full px-1.5 py-0.5 text-[10px] font-semibold"
                :class="row.hasEngine ? 'bg-green-100 text-green-800' : 'bg-[var(--color-gray-09)] text-[var(--color-gray-05)]'"
              >
                {{ row.hasEngine ? 'sim' : 'não' }}
              </span>
            </td>
            <td
              class="border-b border-[var(--color-gray-02)] py-1 text-right font-semibold"
              :class="{ 'text-[var(--color-gray-04)]': row.count === 0 }"
            >
              {{ row.count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p
      v-if="unsupportedInMatrix.length > 0"
      class="text-red-700"
    >
      Esta matriz usa {{ unsupportedInMatrix.length }} tipo(s) sem motor: eles aparecem na folha como "tipo não suportado".
    </p>
    <p
      v-else
      class="text-green-700"
    >
      Todos os tipos usados nesta matriz têm motor.
    </p>
  </LabSection>
</template>
